import { Fornecedor } from './fornecedor.model';
import { NTECH_API } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class FornecedorService {

    constructor(private http: Http) {
    }

    getFornecedores(): Observable<Fornecedor[]> {
        return this.http.get(`${NTECH_API}/fornecedor`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/fornecedor/fornecedor.service.ts